import {Size} from '../types'

/** Determines whether two sizes are equal by value. */
export default function areSizesEqual(a: Size, b: Size): boolean {
  return a.height === b.height && a.width === b.width
}
